// Quiz questions for each course - 80% passing score required for CEU credits
export const COURSE_QUIZZES = {
  // RNCM Track Quizzes
  "rncm-1": {
    title: "Hospice Eligibility & LCDs",
    passingScore: 80,
    questions: [
      { id: 1, question: "What does LCD stand for in hospice?", options: ["Local Coverage Determination", "Limited Care Document", "Long-term Care Directive", "Licensed Care Designation"], correctAnswer: 0, explanation: "LCD = Local Coverage Determination - Medicare guidelines for hospice eligibility." },
      { id: 2, question: "What is the general prognosis requirement for hospice eligibility?", options: ["3 months or less", "6 months or less if disease runs normal course", "1 year or less", "No time requirement"], correctAnswer: 1, explanation: "Medicare requires prognosis of 6 months or less if the disease runs its normal course." },
      { id: 3, question: "Which is a terminal prognosis indicator for CHF?", options: ["EF > 50%", "Optimal on medications", "NYHA Class IV despite optimal treatment", "Mild symptoms with exertion"], correctAnswer: 2, explanation: "NYHA Class IV (symptoms at rest despite treatment) indicates terminal CHF." },
      { id: 4, question: "What PPS score generally indicates hospice eligibility?", options: ["80% or higher", "70% or higher", "50% or lower", "Any PPS score"], correctAnswer: 2, explanation: "PPS (Palliative Performance Scale) of 50% or lower typically supports hospice eligibility." },
      { id: 5, question: "When should LCD criteria be documented?", options: ["Only at admission", "At admission and with each recertification", "Once per year", "Only if surveyed"], correctAnswer: 1, explanation: "LCD criteria must be documented at admission and reassessed at each recertification period." }
    ]
  },
  "rncm-2": {
    title: "Initial POC & Assessments",
    passingScore: 80,
    questions: [
      { id: 1, question: "Which domains must be assessed in a comprehensive hospice assessment?", options: ["Physical only", "Physical and psychosocial", "Physical, psychosocial, spiritual, bereavement", "Only what patient requests"], correctAnswer: 2, explanation: "All four domains must be assessed: physical, psychosocial, spiritual, and bereavement." },
      { id: 2, question: "How should medications be aligned in hospice?", options: ["Continue all current medications", "Related to terminal diagnosis and comfort", "Stop all medications", "Only pain medications"], correctAnswer: 1, explanation: "Medications should be related to the terminal diagnosis or comfort measures." },
      { id: 3, question: "What determines initial visit frequency?", options: ["Insurance requirements", "Patient/family needs and symptom acuity", "Standard weekly schedule", "Physician preference only"], correctAnswer: 1, explanation: "Visit frequency is individualized based on patient needs and symptom acuity." },
      { id: 4, question: "When must the initial POC be completed?", options: ["Within 5 days of admission", "Within 48 hours", "Within 30 days", "No specific timeframe"], correctAnswer: 0, explanation: "Medicare requires POC completion within 5 calendar days of admission." },
      { id: 5, question: "What must be included in bereavement assessment?", options: ["Only after death planning", "Risk factors, support systems, coping history", "Funeral preferences only", "Financial concerns only"], correctAnswer: 1, explanation: "Bereavement assessment includes risk factors, support systems, and coping history." }
    ]
  },
  "rncm-7": {
    title: "Hospitalizations & CAP",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is CAP in hospice quality measures?", options: ["Care Administration Protocol", "Conditions of Administrative Practice", "Claims-based Administrative Penalties", "Hospice Compare quality measure"], correctAnswer: 3, explanation: "CAP relates to quality measures tracked on Hospice Compare." },
      { id: 2, question: "Which is an early warning sign of potential hospitalization?", options: ["Stable vital signs", "New or worsening symptoms not addressed", "Family satisfied with care", "Regular visit schedule maintained"], correctAnswer: 1, explanation: "New/worsening symptoms not promptly addressed may lead to unnecessary hospitalization." },
      { id: 3, question: "What should be documented when preventing hospitalization?", options: ["Nothing specific needed", "Interventions tried and response", "Only if hospitalization occurs", "Family complaints only"], correctAnswer: 1, explanation: "Document all interventions attempted and patient response to demonstrate appropriate care." },
      { id: 4, question: "When a patient is hospitalized, what should hospice do?", options: ["Discharge from hospice automatically", "Coordinate with hospital and visit as able", "Wait until discharge to contact", "Bill for continuous care"], correctAnswer: 1, explanation: "Hospice should coordinate with the hospital and maintain contact with patient/family." },
      { id: 5, question: "What does revocation mean in hospice?", options: ["Patient is discharged for non-compliance", "Patient voluntarily leaves hospice benefit", "Hospice cancels services", "Insurance denies coverage"], correctAnswer: 1, explanation: "Revocation is when a patient voluntarily chooses to leave the hospice benefit." }
    ]
  },
  // Wound Care Quizzes
  "wound-1": {
    title: "Hospice Wound Care Fundamentals",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is the primary goal of wound care in hospice?", options: ["Complete wound healing", "Comfort and containment", "Surgical intervention", "Aggressive debridement"], correctAnswer: 1, explanation: "Hospice wound care focuses on comfort and containment rather than healing." },
      { id: 2, question: "How does hospice wound care differ from traditional wound care?", options: ["No difference", "Focus on palliation vs. healing", "More aggressive treatment", "Less frequent dressing changes"], correctAnswer: 1, explanation: "Hospice prioritizes comfort and symptom management over wound healing." },
      { id: 3, question: "What should be assessed with every wound?", options: ["Size only", "Size, appearance, drainage, odor, pain", "Color only", "Only if patient complains"], correctAnswer: 1, explanation: "Comprehensive wound assessment includes size, appearance, drainage, odor, and pain." },
      { id: 4, question: "When is wound pain most important to address?", options: ["Only during dressing changes", "At all times - it affects quality of life", "Only if severe", "Pain is expected and unavoidable"], correctAnswer: 1, explanation: "Wound pain significantly impacts quality of life and should always be addressed." },
      { id: 5, question: "What is the role of family in hospice wound care?", options: ["No role - nurses only", "Education and simple care participation", "Full wound care responsibility", "Only observation"], correctAnswer: 1, explanation: "Families can be educated to participate in simple wound care between visits." }
    ]
  },
  "wound-2": {
    title: "Pressure Injury Staging",
    passingScore: 80,
    questions: [
      { id: 1, question: "What characterizes a Stage 1 pressure injury?", options: ["Open wound", "Non-blanchable redness on intact skin", "Full thickness tissue loss", "Exposed bone"], correctAnswer: 1, explanation: "Stage 1 = intact skin with non-blanchable redness." },
      { id: 2, question: "What characterizes a Stage 3 pressure injury?", options: ["Intact skin with redness", "Partial thickness skin loss", "Full thickness skin loss, fat visible", "Exposed bone/tendon"], correctAnswer: 2, explanation: "Stage 3 = full thickness skin loss with visible fat, no bone/tendon exposed." },
      { id: 3, question: "What is an unstageable pressure injury?", options: ["Any new wound", "Full thickness loss obscured by slough/eschar", "Stage 1 wound", "Healed pressure injury"], correctAnswer: 1, explanation: "Unstageable = full thickness loss where base is obscured by slough or eschar." },
      { id: 4, question: "What is deep tissue injury (DTI)?", options: ["Stage 4 wound", "Intact skin with purple/maroon discoloration", "Superficial abrasion", "Surgical wound"], correctAnswer: 1, explanation: "DTI = intact or non-intact skin with purple/maroon discoloration from deep tissue damage." },
      { id: 5, question: "Can pressure injuries be reverse-staged as they heal?", options: ["Yes, always", "No - document as 'healing Stage X'", "Only Stage 1-2", "Yes, for documentation purposes"], correctAnswer: 1, explanation: "Pressure injuries cannot be reverse-staged; document as 'healing Stage X wound.'" }
    ]
  },
  // Aide Track Quizzes
  "aide-1": {
    title: "Hospice Aide Role",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is the hospice aide's primary role?", options: ["Medical treatments", "Personal care and comfort", "Medication administration", "Wound care"], correctAnswer: 1, explanation: "Aides provide personal care and comfort measures within their scope." },
      { id: 2, question: "What must aides always report to the RN?", options: ["Nothing unless asked", "Any changes in patient condition", "Only emergencies", "Only skin issues"], correctAnswer: 1, explanation: "Any change in patient condition must be reported to the supervising RN." },
      { id: 3, question: "Can aides administer medications?", options: ["Yes, all medications", "Only PRN medications", "No, outside scope of practice", "Only with family present"], correctAnswer: 2, explanation: "Medication administration is outside the aide scope of practice." },
      { id: 4, question: "How should aides document care?", options: ["No documentation required", "Document all care provided and observations", "Only document problems", "Verbal report only"], correctAnswer: 1, explanation: "Aides must document all care provided and relevant observations." },
      { id: 5, question: "What is the aide's role in the IDT?", options: ["No role in team", "Valuable member providing patient insights", "Only attends if problems", "Makes care decisions"], correctAnswer: 1, explanation: "Aides are valuable IDT members who provide important patient observations." }
    ]
  },
  "aide-2": {
    title: "Personal Care & Comfort",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is most important during personal care?", options: ["Speed and efficiency", "Patient dignity and comfort", "Following exact routine", "Complete independence"], correctAnswer: 1, explanation: "Maintaining patient dignity and comfort is paramount during personal care." },
      { id: 2, question: "How should you position a patient for comfort?", options: ["Same position always", "Based on patient preference and medical needs", "Flat on back only", "Only as family directs"], correctAnswer: 1, explanation: "Positioning should balance patient preference with medical needs." },
      { id: 3, question: "Why is oral care important in hospice?", options: ["Only for appearance", "Comfort, preventing infection, dignity", "Not important at end of life", "Only if patient requests"], correctAnswer: 1, explanation: "Oral care provides comfort, prevents infection, and maintains dignity." },
      { id: 4, question: "What should you do if patient refuses care?", options: ["Insist on completing care", "Respect refusal and document", "Call family to convince them", "Skip documentation"], correctAnswer: 1, explanation: "Respect patient autonomy, document refusal, and report to RN." },
      { id: 5, question: "How can aides support patient dignity?", options: ["Rush through care", "Privacy, choice, gentle communication", "Make all decisions for patient", "Avoid eye contact"], correctAnswer: 1, explanation: "Dignity is supported through privacy, offering choices, and gentle communication." }
    ]
  },
  "aide-4": {
    title: "End-of-Life Comfort Care",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is a sign that death may be near?", options: ["Increased appetite", "Mottled skin, decreased responsiveness", "More energy", "Improved vital signs"], correctAnswer: 1, explanation: "Mottled skin and decreased responsiveness are signs death may be approaching." },
      { id: 2, question: "How should aides support families during active dying?", options: ["Leave them alone", "Quiet presence, simple comfort measures", "Provide medical explanations", "Focus only on patient"], correctAnswer: 1, explanation: "Quiet presence and simple comfort measures support families during this time." },
      { id: 3, question: "What comfort measure is appropriate during active dying?", options: ["Encourage eating and drinking", "Mouth care, repositioning, calm environment", "Aggressive suctioning", "Keep room bright and active"], correctAnswer: 1, explanation: "Mouth care, gentle repositioning, and calm environment provide comfort." },
      { id: 4, question: "Why is hearing considered the last sense to go?", options: ["It's a myth", "Brain areas for hearing remain active longer", "Only in some patients", "No scientific basis"], correctAnswer: 1, explanation: "The auditory cortex often remains active; speak kindly even if patient appears unresponsive." },
      { id: 5, question: "What should aides do for self-care after a patient death?", options: ["Nothing special needed", "Acknowledge grief, use support resources", "Never discuss with anyone", "Immediately see next patient"], correctAnswer: 1, explanation: "Aides should acknowledge their grief and use available support resources." }
    ]
  },
  // ELNEC Core Modules
  "elnec-1": {
    title: "Introduction to Palliative Nursing",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the primary goal of palliative care?",
        options: [
          "To cure the underlying disease",
          "To improve quality of life for patients and families facing serious illness",
          "To hasten the end of life",
          "To reduce healthcare costs"
        ],
        correctAnswer: 1,
        explanation: "Palliative care focuses on improving quality of life for patients and families facing serious illness through prevention and relief of suffering."
      },
      {
        id: 2,
        question: "Which domains are addressed in holistic palliative care assessment?",
        options: [
          "Physical and emotional only",
          "Physical, psychological, social, and spiritual",
          "Medical and financial",
          "Psychological and spiritual only"
        ],
        correctAnswer: 1,
        explanation: "Holistic palliative care addresses all four domains: physical, psychological, social, and spiritual needs of the patient."
      },
      {
        id: 3,
        question: "When should palliative care be introduced?",
        options: [
          "Only in the last days of life",
          "At any stage of a serious illness, alongside curative treatment",
          "Only after all curative options have failed",
          "Only for cancer patients"
        ],
        correctAnswer: 1,
        explanation: "Palliative care can be provided at any stage of serious illness, concurrent with curative or life-prolonging treatments."
      },
      {
        id: 4,
        question: "What is the nurse's primary role in the interprofessional palliative care team?",
        options: [
          "To prescribe medications",
          "To coordinate care, advocate for patients, and provide direct symptom management",
          "To provide spiritual counseling only",
          "To make end-of-life decisions for families"
        ],
        correctAnswer: 1,
        explanation: "Nurses coordinate care, serve as patient advocates, assess and manage symptoms, and facilitate communication within the team."
      },
      {
        id: 5,
        question: "Which statement about hospice and palliative care is TRUE?",
        options: [
          "They are exactly the same thing",
          "Hospice is a type of palliative care for patients with a prognosis of 6 months or less",
          "Palliative care is only for dying patients",
          "Hospice care includes aggressive curative treatments"
        ],
        correctAnswer: 1,
        explanation: "Hospice is a specialized form of palliative care for patients with a life expectancy of 6 months or less who choose comfort-focused care."
      }
    ]
  },
  "elnec-2": {
    title: "Communication in Palliative Care",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the most important element of therapeutic communication in palliative care?",
        options: [
          "Speaking quickly to cover all information",
          "Active listening and mindful presence",
          "Avoiding emotional topics",
          "Using medical terminology"
        ],
        correctAnswer: 1,
        explanation: "Active listening and being fully present allows patients and families to feel heard and supported."
      },
      {
        id: 2,
        question: "When delivering serious news, what approach is recommended?",
        options: [
          "Deliver all information at once to save time",
          "Use the SPIKES protocol: Setting, Perception, Invitation, Knowledge, Emotions, Summary",
          "Have a family member deliver the news instead",
          "Focus only on the medical facts"
        ],
        correctAnswer: 1,
        explanation: "The SPIKES protocol provides a framework for compassionate, patient-centered communication of serious news."
      },
      {
        id: 3,
        question: "How should nurses respond when a patient expresses fear about dying?",
        options: [
          "Change the subject to something positive",
          "Acknowledge the fear and explore what specifically concerns them",
          "Reassure them that everything will be fine",
          "Call for the chaplain immediately"
        ],
        correctAnswer: 1,
        explanation: "Acknowledging fears and exploring concerns validates the patient's emotions and allows for targeted support."
      },
      {
        id: 4,
        question: "What does 'Ask-Tell-Ask' communication technique involve?",
        options: [
          "Asking questions three times for clarity",
          "Asking what the patient knows, telling information, then asking what they understood",
          "Asking the doctor, telling the patient, asking the family",
          "A technique only for pediatric patients"
        ],
        correctAnswer: 1,
        explanation: "Ask-Tell-Ask helps assess understanding, provide information, and verify comprehension in patient education."
      },
      {
        id: 5,
        question: "When family members disagree about care decisions, the nurse should:",
        options: [
          "Side with the majority of family members",
          "Facilitate a family meeting to discuss values and the patient's wishes",
          "Make the decision for the family",
          "Avoid involvement in family discussions"
        ],
        correctAnswer: 1,
        explanation: "Family meetings help clarify values, honor patient wishes, and work toward consensus in care decisions."
      }
    ]
  },
  "elnec-3": {
    title: "Pain Assessment and Management",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the gold standard for pain assessment?",
        options: [
          "Vital signs",
          "Patient's self-report",
          "Behavioral observation only",
          "Family member's assessment"
        ],
        correctAnswer: 1,
        explanation: "The patient's self-report is the most reliable indicator of pain presence and intensity."
      },
      {
        id: 2,
        question: "Which pain scale is most appropriate for a non-verbal patient with advanced dementia?",
        options: [
          "Numeric Rating Scale (0-10)",
          "PAINAD (Pain Assessment in Advanced Dementia)",
          "Wong-Baker FACES scale",
          "Visual Analog Scale"
        ],
        correctAnswer: 1,
        explanation: "PAINAD uses behavioral indicators to assess pain in patients who cannot self-report."
      },
      {
        id: 3,
        question: "What is breakthrough pain?",
        options: [
          "Pain that occurs only at night",
          "Transient pain that occurs despite around-the-clock pain management",
          "Pain caused by medication side effects",
          "Pain that never responds to treatment"
        ],
        correctAnswer: 1,
        explanation: "Breakthrough pain is a temporary flare of pain that occurs despite regular pain medication regimen."
      },
      {
        id: 4,
        question: "Which statement about opioid tolerance is TRUE?",
        options: [
          "Tolerance means the patient is addicted",
          "Tolerance is a normal physiological adaptation requiring dose adjustment",
          "Tolerance means opioids should be stopped",
          "Tolerance only occurs in patients with substance abuse history"
        ],
        correctAnswer: 1,
        explanation: "Tolerance is a normal physiological response where higher doses may be needed to achieve the same effect."
      },
      {
        id: 5,
        question: "What is equianalgesic dosing used for?",
        options: [
          "Calculating the equivalent dose when switching between different opioids",
          "Determining the maximum safe dose",
          "Calculating pediatric doses",
          "Adjusting doses for renal failure only"
        ],
        correctAnswer: 0,
        explanation: "Equianalgesic dosing helps calculate equivalent doses when rotating or switching opioid medications."
      }
    ]
  },
  "elnec-4": {
    title: "Symptom Management",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is dyspnea in palliative care?",
        options: [
          "Low oxygen levels on pulse oximetry",
          "The subjective experience of breathing discomfort",
          "Rapid respiratory rate",
          "Audible lung sounds"
        ],
        correctAnswer: 1,
        explanation: "Dyspnea is the subjective sensation of breathlessness, which may not correlate with oxygen levels."
      },
      {
        id: 2,
        question: "Which intervention can help relieve dyspnea in addition to medications?",
        options: [
          "Keeping the room warm and closed",
          "Fan therapy directed at the face",
          "Encouraging deep breathing exercises",
          "Limiting fluid intake"
        ],
        correctAnswer: 1,
        explanation: "A fan or cool air directed at the face can stimulate facial receptors and reduce the sensation of breathlessness."
      },
      {
        id: 3,
        question: "What is the most common cause of nausea in advanced illness?",
        options: [
          "Anxiety",
          "Multiple factors including medications, constipation, and metabolic changes",
          "Overeating",
          "Dehydration alone"
        ],
        correctAnswer: 1,
        explanation: "Nausea in advanced illness is often multifactorial and requires assessment of various contributing causes."
      },
      {
        id: 4,
        question: "Terminal secretions ('death rattle') are best managed by:",
        options: [
          "Aggressive suctioning",
          "Positioning and anticholinergic medications, with family education",
          "Increasing IV fluids",
          "Intubation"
        ],
        correctAnswer: 1,
        explanation: "Repositioning and anticholinergic medications reduce secretions; family education that this is normal and not distressing to the patient is essential."
      },
      {
        id: 5,
        question: "Which approach to constipation management is recommended for patients on opioids?",
        options: [
          "Wait until constipation develops before treating",
          "Prophylactic bowel regimen started when opioids are initiated",
          "Fiber supplements alone",
          "Enemas only"
        ],
        correctAnswer: 1,
        explanation: "Prophylactic bowel regimens should be started when opioids are prescribed since constipation is an expected side effect."
      }
    ]
  },
  "elnec-5": {
    title: "Loss, Grief, and Bereavement",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is anticipatory grief?",
        options: [
          "Grief that only occurs after death",
          "Grief experienced before an expected loss",
          "Grief that is excessive and needs treatment",
          "Grief experienced only by healthcare providers"
        ],
        correctAnswer: 1,
        explanation: "Anticipatory grief occurs before a loss and can help individuals prepare emotionally for an impending death."
      },
      {
        id: 2,
        question: "Which statement about grief is TRUE?",
        options: [
          "Everyone grieves in the same way",
          "Grief follows predictable stages that occur in order",
          "Grief is unique to each individual and there is no 'right' way to grieve",
          "Grief should be resolved within one year"
        ],
        correctAnswer: 2,
        explanation: "Grief is a highly individual experience; there is no universal timeline or correct way to grieve."
      },
      {
        id: 3,
        question: "What is compassion fatigue?",
        options: [
          "Being too compassionate with patients",
          "Emotional and physical exhaustion from caring for those who are suffering",
          "A sign that someone should leave healthcare",
          "A rare condition affecting few healthcare workers"
        ],
        correctAnswer: 1,
        explanation: "Compassion fatigue is the cumulative emotional and physical exhaustion that can affect caregivers who repeatedly witness suffering."
      },
      {
        id: 4,
        question: "Which is a sign of complicated grief that may require professional intervention?",
        options: [
          "Crying when remembering the deceased",
          "Persistent inability to function in daily life 6+ months after loss",
          "Feeling sad on anniversaries",
          "Keeping photos of the deceased"
        ],
        correctAnswer: 1,
        explanation: "Prolonged, severe impairment in daily functioning may indicate complicated grief requiring professional support."
      },
      {
        id: 5,
        question: "What is an effective self-care strategy for hospice nurses?",
        options: [
          "Avoiding attachment to any patients",
          "Regular debriefing, peer support, and maintaining work-life boundaries",
          "Working longer hours to help more patients",
          "Keeping emotions completely suppressed"
        ],
        correctAnswer: 1,
        explanation: "Regular debriefing, peer support, and healthy boundaries help prevent burnout and compassion fatigue."
      }
    ]
  },
  "elnec-6": {
    title: "Final Hours of Life",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "Which is a common sign that death may occur within hours to days?",
        options: [
          "Increased appetite",
          "Mottling of extremities, decreased urine output, and altered consciousness",
          "Improved pain control without medication",
          "Return of normal sleep patterns"
        ],
        correctAnswer: 1,
        explanation: "Signs of imminent death include mottling, decreased urine output, changes in breathing, and decreased consciousness."
      },
      {
        id: 2,
        question: "What should be the focus of care in the final hours of life?",
        options: [
          "Aggressive hydration and nutrition",
          "Comfort, dignity, and support for patient and family",
          "Frequent vital sign monitoring",
          "Laboratory testing to monitor organ function"
        ],
        correctAnswer: 1,
        explanation: "Care in the final hours focuses on comfort, maintaining dignity, and supporting the patient and family."
      },
      {
        id: 3,
        question: "Cheyne-Stokes breathing is:",
        options: [
          "Always a medical emergency requiring intervention",
          "A pattern of breathing with periods of apnea, common at end of life",
          "Caused by pain and should be treated with opioids",
          "A sign the patient is in distress"
        ],
        correctAnswer: 1,
        explanation: "Cheyne-Stokes breathing is a normal end-of-life breathing pattern with alternating deep breaths and apnea periods."
      },
      {
        id: 4,
        question: "How should artificial nutrition be approached in actively dying patients?",
        options: [
          "Always continue to prevent starvation",
          "Discontinue if it causes discomfort; the body naturally decreases need for nutrition",
          "Increase calories to maintain strength",
          "Switch to IV nutrition"
        ],
        correctAnswer: 1,
        explanation: "The dying body naturally decreases its need for nutrition; forcing food can cause discomfort and complications."
      },
      {
        id: 5,
        question: "What is important for families to understand about hearing in dying patients?",
        options: [
          "Hearing is lost first",
          "Hearing may remain intact even when the patient appears unresponsive",
          "Only loud voices can be heard",
          "Patients cannot hear anything in coma"
        ],
        correctAnswer: 1,
        explanation: "Hearing is often the last sense to fade; families should be encouraged to speak to their loved one even if unresponsive."
      }
    ]
  },
  // Hospice Fundamentals
  "fund-1": {
    title: "Crash Course: Hospice Care Primer",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the typical prognosis requirement for hospice eligibility?",
        options: [
          "3 months or less",
          "6 months or less if the disease runs its normal course",
          "1 year or less",
          "No specific time requirement"
        ],
        correctAnswer: 1,
        explanation: "Medicare hospice benefit requires a prognosis of 6 months or less if the illness runs its normal course."
      },
      {
        id: 2,
        question: "Which service is typically NOT covered under Medicare hospice?",
        options: [
          "Pain medications",
          "Curative treatments for the terminal diagnosis",
          "Respite care",
          "Medical equipment"
        ],
        correctAnswer: 1,
        explanation: "Hospice focuses on comfort; curative treatments for the terminal illness are not covered."
      },
      {
        id: 3,
        question: "Who is part of the hospice interdisciplinary team (IDT)?",
        options: [
          "Only nurses and doctors",
          "Physician, nurse, social worker, chaplain, aide, and volunteers",
          "Only medical professionals",
          "Nurse and family members only"
        ],
        correctAnswer: 1,
        explanation: "The IDT includes diverse professionals to address all aspects of patient and family needs."
      },
      {
        id: 4,
        question: "What is respite care in hospice?",
        options: [
          "Care provided at the patient's workplace",
          "Short-term inpatient care to give family caregivers a break",
          "Care provided by the patient's children",
          "Emergency room care"
        ],
        correctAnswer: 1,
        explanation: "Respite care provides temporary inpatient care (up to 5 days) to allow family caregivers rest."
      },
      {
        id: 5,
        question: "Can a patient revoke hospice and return to curative treatment?",
        options: [
          "No, hospice is permanent",
          "Yes, patients can revoke hospice at any time",
          "Only with physician approval",
          "Only within the first week"
        ],
        correctAnswer: 1,
        explanation: "Patients have the right to revoke hospice at any time and can later re-enroll if eligible."
      }
    ]
  },
  "fund-2": {
    title: "Hospice 101: Everything You Need to Know",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is a common misconception about hospice care?",
        options: [
          "That it provides pain management",
          "That choosing hospice means 'giving up' or hastening death",
          "That it includes social work services",
          "That families are involved in care"
        ],
        correctAnswer: 1,
        explanation: "A common myth is that hospice hastens death; in reality, studies show hospice patients often live longer with better quality of life."
      },
      {
        id: 2,
        question: "Where can hospice care be provided?",
        options: [
          "Only in hospitals",
          "Home, nursing facilities, assisted living, or inpatient hospice units",
          "Only in dedicated hospice facilities",
          "Only in the patient's home"
        ],
        correctAnswer: 1,
        explanation: "Hospice care can be provided wherever the patient calls home, including various facility settings."
      },
      {
        id: 3,
        question: "What does hospice provide for family caregivers?",
        options: [
          "No support - focus is only on patient",
          "Education, emotional support, respite, and bereavement services",
          "Financial payments",
          "Mandatory counseling"
        ],
        correctAnswer: 1,
        explanation: "Hospice provides comprehensive support to families including education, counseling, respite, and bereavement care."
      },
      {
        id: 4,
        question: "How often are hospice patients typically visited by nurses?",
        options: [
          "Once a month",
          "Based on the patient's individual needs and plan of care",
          "Daily for all patients",
          "Only when requested by family"
        ],
        correctAnswer: 1,
        explanation: "Visit frequency is individualized based on patient needs, symptoms, and care plan goals."
      },
      {
        id: 5,
        question: "What is bereavement care in hospice?",
        options: [
          "Care provided only before death",
          "Support services for families for up to 13 months after the patient's death",
          "Only funeral planning assistance",
          "Medical care for grieving family members"
        ],
        correctAnswer: 1,
        explanation: "Medicare requires hospices to offer bereavement support to families for at least 13 months after death."
      }
    ]
  },
  "fund-3": {
    title: "Hospice Care Training 2025",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the role of the hospice volunteer?",
        options: [
          "To provide medical care",
          "To provide companionship, respite, and support services",
          "To make medical decisions",
          "To replace paid staff"
        ],
        correctAnswer: 1,
        explanation: "Volunteers provide valuable non-medical support including companionship and respite for families."
      },
      {
        id: 2,
        question: "What documentation is required for hospice admission?",
        options: [
          "Only a verbal request",
          "Physician certification of terminal illness and patient consent",
          "Family consent only",
          "Hospital discharge papers only"
        ],
        correctAnswer: 1,
        explanation: "Hospice requires physician certification of terminal prognosis and informed consent from patient or surrogate."
      },
      {
        id: 3,
        question: "What is a hospice comfort kit?",
        options: [
          "A gift basket for the family",
          "Emergency medications kept in the home for symptom crises",
          "Cleaning supplies",
          "Entertainment items for the patient"
        ],
        correctAnswer: 1,
        explanation: "Comfort kits contain emergency medications for symptoms like pain, dyspnea, or anxiety to be used under nurse guidance."
      },
      {
        id: 4,
        question: "How should pronouncement of death be handled in hospice?",
        options: [
          "Always call 911 first",
          "Follow agency protocol; a nurse typically pronounces and certifies the death",
          "Only a physician can pronounce death",
          "Family members should call the funeral home first"
        ],
        correctAnswer: 1,
        explanation: "Hospice nurses are typically authorized to pronounce death; families should call hospice, not 911."
      },
      {
        id: 5,
        question: "What determines the level of care a hospice patient receives?",
        options: [
          "Insurance type only",
          "Patient symptoms, needs, and setting determine routine, continuous, respite, or inpatient care",
          "Family preference alone",
          "Length of time on hospice"
        ],
        correctAnswer: 1,
        explanation: "Four levels of Medicare hospice care exist based on patient needs: routine, continuous, respite, and general inpatient."
      }
    ]
  },
  // Pain Management
  "pain-1": {
    title: "Pain Assessment & Management Fundamentals",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What does the 'P' in the PQRST pain assessment stand for?",
        options: [
          "Position",
          "Provokes/Palliates - what makes pain better or worse",
          "Pressure",
          "Pulse"
        ],
        correctAnswer: 1,
        explanation: "P = Provokes/Palliates (what triggers or relieves pain), Q = Quality, R = Region/Radiation, S = Severity, T = Timing."
      },
      {
        id: 2,
        question: "Which assessment finding suggests neuropathic pain?",
        options: [
          "Dull, aching pain",
          "Burning, shooting, or 'electric shock' sensations",
          "Pain that improves with pressure",
          "Pain only with movement"
        ],
        correctAnswer: 1,
        explanation: "Neuropathic pain typically presents as burning, shooting, tingling, or electric shock-like sensations."
      },
      {
        id: 3,
        question: "How often should pain be reassessed after an intervention?",
        options: [
          "Once daily",
          "Within an appropriate timeframe based on intervention (e.g., 30-60 min for oral meds)",
          "Only if patient complains",
          "At the next visit"
        ],
        correctAnswer: 1,
        explanation: "Pain should be reassessed at peak effect time of the intervention to evaluate effectiveness."
      },
      {
        id: 4,
        question: "What is the recommended first-line treatment for mild cancer pain?",
        options: [
          "Strong opioids",
          "Non-opioid analgesics like acetaminophen or NSAIDs",
          "Nerve blocks",
          "Radiation therapy"
        ],
        correctAnswer: 1,
        explanation: "WHO pain ladder recommends non-opioids for mild pain, with opioids added as pain increases."
      },
      {
        id: 5,
        question: "What is adjuvant pain medication?",
        options: [
          "Medication given only at night",
          "Medications with primary uses other than pain that help with certain pain types",
          "Over-the-counter medications only",
          "Medications that replace opioids"
        ],
        correctAnswer: 1,
        explanation: "Adjuvants include antidepressants, anticonvulsants, and steroids that enhance pain relief for specific pain types."
      }
    ]
  },
  "pain-2": {
    title: "Hospice & Palliative Care - Beyond the Myths",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the myth about morphine hastening death?",
        options: [
          "It is completely true",
          "Appropriately dosed opioids for pain relief do not hasten death",
          "Morphine always causes respiratory failure",
          "Only IV morphine is safe"
        ],
        correctAnswer: 1,
        explanation: "When dosed appropriately for pain, opioids are safe and do not hasten death in palliative care."
      },
      {
        id: 2,
        question: "What is palliative sedation?",
        options: [
          "Regular use of sleeping pills",
          "Intentionally reducing consciousness to relieve refractory suffering at end of life",
          "Euthanasia by another name",
          "Sedation for medical procedures"
        ],
        correctAnswer: 1,
        explanation: "Palliative sedation is used for refractory symptoms when other treatments have failed; it differs ethically from euthanasia."
      },
      {
        id: 3,
        question: "When should palliative care be initiated for a patient with serious illness?",
        options: [
          "Only at the very end of life",
          "Early in the disease course, alongside disease-directed treatment",
          "Only when cure is impossible",
          "Only after hospice referral"
        ],
        correctAnswer: 1,
        explanation: "Early palliative care integration improves quality of life and may even extend survival."
      },
      {
        id: 4,
        question: "What is the 'double effect' principle in palliative care?",
        options: [
          "Giving two medications at once",
          "An action intended to relieve suffering is ethical even if it has a foreseeable but unintended negative effect",
          "Treating two symptoms simultaneously",
          "The effect of withdrawal and rebound"
        ],
        correctAnswer: 1,
        explanation: "Double effect justifies treatments that relieve suffering even if they might have unintended effects like sedation."
      },
      {
        id: 5,
        question: "What distinguishes palliative care from hospice?",
        options: [
          "They are the same thing",
          "Palliative care can be provided at any illness stage; hospice requires a terminal prognosis",
          "Hospice provides better pain management",
          "Only palliative care is covered by Medicare"
        ],
        correctAnswer: 1,
        explanation: "Palliative care is appropriate at any illness stage; hospice specifically serves those with ≤6 month prognosis."
      }
    ]
  },
  // Timely Response
  "timely-1": {
    title: "Rapid Response Protocol Training",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the recommended callback time for urgent hospice calls?",
        options: [
          "Within 4 hours",
          "Within 30 minutes",
          "Next business day",
          "Within 24 hours"
        ],
        correctAnswer: 1,
        explanation: "Best practice is to return urgent calls within 30 minutes to address patient and family needs promptly."
      },
      {
        id: 2,
        question: "Which situation requires immediate nurse response?",
        options: [
          "Routine medication refill request",
          "Uncontrolled pain, severe dyspnea, or signs of active dying",
          "Question about visiting hours",
          "Request for more supplies"
        ],
        correctAnswer: 1,
        explanation: "Symptom crises and signs of imminent death require immediate nursing response."
      },
      {
        id: 3,
        question: "What should be documented after every phone triage?",
        options: [
          "Nothing if no visit is made",
          "Caller, complaint, assessment, advice given, and follow-up plan",
          "Only the date and time",
          "Only if medications were ordered"
        ],
        correctAnswer: 1,
        explanation: "Complete documentation of all triage calls protects patients and staff and ensures continuity of care."
      },
      {
        id: 4,
        question: "When should continuous care be considered?",
        options: [
          "For all hospice patients",
          "During brief periods of crisis when skilled nursing is needed to achieve comfort",
          "Only in inpatient settings",
          "When family requests 24-hour care"
        ],
        correctAnswer: 1,
        explanation: "Continuous care provides intense nursing presence during symptom crises until comfort is achieved."
      },
      {
        id: 5,
        question: "What is the best way to prevent after-hours crises?",
        options: [
          "Avoid giving families your phone number",
          "Proactive symptom management, family education, and anticipatory prescribing",
          "Only visit during business hours",
          "Have families call 911"
        ],
        correctAnswer: 1,
        explanation: "Anticipating needs, educating families, and having PRN medications available prevents many crises."
      }
    ]
  },
  "timely-2": {
    title: "Effective Triage Communication",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the first priority when receiving an urgent call?",
        options: [
          "Asking for insurance information",
          "Assessing the immediate safety and severity of the situation",
          "Scheduling the next routine visit",
          "Transferring to voicemail"
        ],
        correctAnswer: 1,
        explanation: "Safety and severity assessment should always come first in triage to determine urgency of response."
      },
      {
        id: 2,
        question: "How should you respond to an anxious caller?",
        options: [
          "Ask them to calm down before continuing",
          "Use a calm voice, acknowledge their concern, and gather information systematically",
          "Transfer them to someone else",
          "Tell them their concerns are minor"
        ],
        correctAnswer: 1,
        explanation: "Remaining calm, validating concerns, and systematic assessment helps anxious callers feel supported."
      },
      {
        id: 3,
        question: "What question helps assess pain severity over the phone?",
        options: [
          "Is the pain bad?",
          "On a scale of 0-10, how would you rate the pain right now?",
          "Have you taken your medication?",
          "When did you last eat?"
        ],
        correctAnswer: 1,
        explanation: "Using standardized scales like 0-10 provides objective measurement for remote pain assessment."
      },
      {
        id: 4,
        question: "When should you advise calling 911?",
        options: [
          "Never for hospice patients",
          "For emergencies outside hospice scope like trauma, or per patient/family goals",
          "For all breathing problems",
          "Whenever family is unsure"
        ],
        correctAnswer: 1,
        explanation: "911 may be appropriate for non-hospice emergencies; this should align with patient goals of care."
      },
      {
        id: 5,
        question: "What is read-back verification?",
        options: [
          "Reading the patient's chart back to them",
          "Repeating back critical information to confirm accuracy",
          "Reading policies to callers",
          "A documentation method"
        ],
        correctAnswer: 1,
        explanation: "Read-back verification ensures accurate communication by confirming critical information like medication doses."
      }
    ]
  },
  // Communication
  "comm-1": {
    title: "Family Communication Skills",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the NURSE mnemonic for responding to emotions?",
        options: [
          "Never, Understand, Respond, Stop, End",
          "Naming, Understanding, Respecting, Supporting, Exploring",
          "No, Usually, Rarely, Sometimes, Everywhere",
          "Needs, Urgent, Routine, Standard, Emergency"
        ],
        correctAnswer: 1,
        explanation: "NURSE: Name the emotion, Understand, Respect, Support, Explore to respond empathetically."
      },
      {
        id: 2,
        question: "How should you handle a family member who is angry about care?",
        options: [
          "Defend the care team immediately",
          "Listen without interruption, acknowledge feelings, and explore concerns",
          "Ask them to leave",
          "Document the complaint and move on"
        ],
        correctAnswer: 1,
        explanation: "Active listening and acknowledging anger helps de-escalate and understand the underlying concerns."
      },
      {
        id: 3,
        question: "What is a 'I wish' statement used for?",
        options: [
          "Expressing the nurse's personal desires",
          "Aligning with family hopes while acknowledging reality (e.g., 'I wish we had a cure too')",
          "Making promises to families",
          "Documenting care preferences"
        ],
        correctAnswer: 1,
        explanation: "'I wish' statements show empathy and alignment with family hopes while gently maintaining honesty."
      },
      {
        id: 4,
        question: "When family members receive bad news, what response is most helpful?",
        options: [
          "Immediately providing more information",
          "Allowing silence and space for emotional processing",
          "Changing the subject",
          "Asking if they have questions right away"
        ],
        correctAnswer: 1,
        explanation: "Silence allows processing; rushing to fill silence or provide more information can overwhelm."
      },
      {
        id: 5,
        question: "What is 'prognostic awareness'?",
        options: [
          "The nurse's understanding of disease progression",
          "The patient's and family's understanding of illness trajectory and prognosis",
          "Insurance coverage awareness",
          "Awareness of all treatment options"
        ],
        correctAnswer: 1,
        explanation: "Prognostic awareness refers to how well patients and families understand the likely disease course."
      }
    ]
  },
  // Default quiz for courses without specific questions
  "default": {
    title: "Course Assessment",
    passingScore: 80,
    questions: [
      {
        id: 1,
        question: "What is the primary focus of hospice and palliative care?",
        options: [
          "Curing disease",
          "Comfort and quality of life",
          "Extending life at all costs",
          "Reducing healthcare costs"
        ],
        correctAnswer: 1,
        explanation: "Hospice and palliative care focus on comfort, symptom management, and quality of life."
      },
      {
        id: 2,
        question: "Which approach is central to end-of-life care?",
        options: [
          "Disease-focused treatment only",
          "Patient-centered, holistic care addressing physical, emotional, social, and spiritual needs",
          "Aggressive interventions",
          "Avoiding difficult conversations"
        ],
        correctAnswer: 1,
        explanation: "Holistic, patient-centered care addresses all dimensions of suffering."
      },
      {
        id: 3,
        question: "What is essential for effective care coordination?",
        options: [
          "Working independently",
          "Clear communication among the interdisciplinary team",
          "Limiting family involvement",
          "Following protocols without flexibility"
        ],
        correctAnswer: 1,
        explanation: "Team communication ensures coordinated, comprehensive patient care."
      },
      {
        id: 4,
        question: "Why is documentation important in hospice?",
        options: [
          "Only for billing purposes",
          "To ensure continuity of care, legal protection, and quality improvement",
          "It's not important in hospice",
          "Only for annual surveys"
        ],
        correctAnswer: 1,
        explanation: "Documentation supports care continuity, legal compliance, and quality assessment."
      },
      {
        id: 5,
        question: "What role does family education play in hospice?",
        options: [
          "Minimal role",
          "Critical role in preparing families to provide care and understand what to expect",
          "Only important for medication administration",
          "Optional service"
        ],
        correctAnswer: 1,
        explanation: "Family education empowers caregivers and reduces anxiety about the end-of-life process."
      }
    ]
  },
  // Social Work Track Quizzes
  "sw-1": {
    title: "Psychosocial Assessment in Hospice",
    passingScore: 80,
    questions: [
      { id: 1, question: "What are the four domains of a comprehensive psychosocial assessment?", options: ["Physical, mental, spiritual, financial", "Social, emotional, practical, financial", "Cognitive, behavioral, emotional, physical", "Cultural, spiritual, psychological, social"], correctAnswer: 3, explanation: "Psychosocial assessments cover cultural, spiritual, psychological, and social domains." },
      { id: 2, question: "Which validated tool is commonly used to screen for depression in hospice?", options: ["MMSE", "PHQ-9 or GDS", "AUDIT-C", "GAD-7 only"], correctAnswer: 1, explanation: "PHQ-9 and Geriatric Depression Scale (GDS) are commonly used depression screening tools in hospice." },
      { id: 3, question: "When should psychosocial assessments be updated?", options: ["Only at admission", "At admission and with significant changes or recertification", "Once per year", "Only if patient requests"], correctAnswer: 1, explanation: "Psychosocial assessments should be updated at admission, with significant changes, and at recertification." },
      { id: 4, question: "What is a key component of documenting psychosocial needs?", options: ["Using only medical terminology", "Linking needs to interventions in the care plan", "Keeping notes brief without detail", "Documenting only problems"], correctAnswer: 1, explanation: "Effective documentation links identified needs to specific interventions in the care plan." },
      { id: 5, question: "How should social workers approach patients who decline services?", options: ["Document refusal and never offer again", "Respect autonomy, document, and revisit as appropriate", "Insist on services for their benefit", "Discharge from hospice"], correctAnswer: 1, explanation: "Respect patient autonomy, document the refusal, and offer services again when appropriate." }
    ]
  },
  "sw-2": {
    title: "Grief & Bereavement Counseling",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is anticipatory grief?", options: ["Grief that occurs after death", "Grief experienced before an expected loss", "Pathological grief response", "Grief that lasts more than a year"], correctAnswer: 1, explanation: "Anticipatory grief is the grieving process that occurs before an expected death." },
      { id: 2, question: "Which is a sign of complicated grief that may need referral?", options: ["Crying when remembering the deceased", "Persistent inability to function 6+ months after death", "Keeping photos of the deceased", "Talking about the deceased"], correctAnswer: 1, explanation: "Persistent inability to function for 6+ months may indicate complicated grief requiring additional support." },
      { id: 3, question: "What is the Medicare requirement for hospice bereavement services?", options: ["6 months", "At least 13 months after death", "3 months", "No requirement"], correctAnswer: 1, explanation: "Medicare requires hospices to offer bereavement support for at least 13 months after the patient's death." },
      { id: 4, question: "How should you respond when a family member says 'I should have done more'?", options: ["Agree that they could have done more", "Normalize the feeling and explore their caregiving experience", "Change the subject", "Provide reassurance immediately"], correctAnswer: 1, explanation: "Normalizing the feeling and exploring their experience helps process guilt in a healthy way." },
      { id: 5, question: "What is a protective factor in grief?", options: ["Social isolation", "Strong social support system", "Avoiding memories of the deceased", "Returning to work immediately"], correctAnswer: 1, explanation: "Strong social support is a key protective factor in healthy grief processing." }
    ]
  },
  "sw-3": {
    title: "Family Systems & Dynamics",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is the primary goal of a family meeting in hospice?", options: ["To convince family of medical decisions", "To facilitate communication and shared decision-making", "To reduce hospice visits", "To assign family responsibilities"], correctAnswer: 1, explanation: "Family meetings facilitate open communication and support shared decision-making." },
      { id: 2, question: "How should you handle family conflict during a care conference?", options: ["Take sides with the majority", "Acknowledge all perspectives and refocus on patient wishes", "End the meeting immediately", "Report the family to administration"], correctAnswer: 1, explanation: "Acknowledge all perspectives while keeping focus on the patient's wishes and best interests." },
      { id: 3, question: "What is a genogram used for?", options: ["Tracking medications", "Visualizing family relationships and patterns", "Scheduling visits", "Billing purposes"], correctAnswer: 1, explanation: "A genogram is a graphic representation of family relationships, history, and patterns." },
      { id: 4, question: "When adult children disagree about a parent's care, what should the social worker do first?", options: ["Make the decision for them", "Identify the legal decision-maker and explore patient's values", "Side with the oldest child", "Involve an attorney"], correctAnswer: 1, explanation: "First identify who has legal authority and explore the patient's expressed values and wishes." },
      { id: 5, question: "What is 'identified patient' in family systems theory?", options: ["The hospice patient", "The person whose symptoms reflect family dysfunction", "The primary caregiver", "The healthcare proxy"], correctAnswer: 1, explanation: "In family systems theory, the identified patient is the person whose symptoms may reflect broader family dynamics." }
    ]
  },
  "sw-4": {
    title: "Community Resources & Care Coordination",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is the social worker's role in care transitions?", options: ["Medical management only", "Coordinating resources and supporting continuity of care", "Only discharge planning", "Financial counseling only"], correctAnswer: 1, explanation: "Social workers coordinate resources and support continuity across care transitions." },
      { id: 2, question: "Which benefit might help a hospice patient with limited income?", options: ["Only Medicare", "Medicaid, VA benefits, community assistance programs", "No assistance is available", "Only private insurance"], correctAnswer: 1, explanation: "Multiple programs may help: Medicaid, VA benefits, community assistance, charitable organizations." },
      { id: 3, question: "What should be considered when referring to community resources?", options: ["Cost only", "Accessibility, cultural appropriateness, and patient preferences", "Proximity only", "Provider preferences"], correctAnswer: 1, explanation: "Consider accessibility, cultural appropriateness, and alignment with patient/family preferences." },
      { id: 4, question: "How can social workers support caregivers experiencing burnout?", options: ["Tell them to try harder", "Connect with respite care, support groups, and self-care resources", "Suggest they quit caregiving", "Document and move on"], correctAnswer: 1, explanation: "Support includes respite referrals, support groups, and practical self-care strategies." },
      { id: 5, question: "What is the purpose of a resource directory?", options: ["Billing reference", "Quick access to vetted community services for patient/family needs", "Staff phone list", "Marketing tool"], correctAnswer: 1, explanation: "A resource directory provides quick access to vetted community services for various patient and family needs." }
    ]
  },
  "sw-5": {
    title: "Ethical Decision-Making in Hospice",
    passingScore: 80,
    questions: [
      { id: 1, question: "What are the four principles of biomedical ethics?", options: ["Safety, quality, efficiency, equity", "Autonomy, beneficence, non-maleficence, justice", "Privacy, dignity, respect, care", "Truth, honesty, integrity, trust"], correctAnswer: 1, explanation: "The four principles are autonomy, beneficence, non-maleficence, and justice." },
      { id: 2, question: "When is an ethics consultation appropriate?", options: ["Never in hospice", "When there is conflict about goals of care or treatment decisions", "Only for legal issues", "Only with physician request"], correctAnswer: 1, explanation: "Ethics consultations help resolve conflicts about goals of care and treatment decisions." },
      { id: 3, question: "What is the role of an advance directive?", options: ["To speed up death", "To document a person's healthcare wishes for when they cannot speak", "To save money", "To limit family involvement"], correctAnswer: 1, explanation: "Advance directives document healthcare wishes to guide care when the person cannot communicate." },
      { id: 4, question: "How should surrogate decision-makers make choices?", options: ["Based on their own preferences", "Based on substituted judgment (what patient would want) or best interest", "Always choosing aggressive care", "Deferring all decisions to doctors"], correctAnswer: 1, explanation: "Surrogates should use substituted judgment (what patient would want) or best interest standard." },
      { id: 5, question: "What is 'moral distress' in healthcare?", options: ["Physical exhaustion", "Knowing the right action but being constrained from taking it", "Disagreeing with policies", "Feeling overworked"], correctAnswer: 1, explanation: "Moral distress occurs when you know the ethically correct action but face barriers to taking it." }
    ]
  },
  // Chaplaincy Track Quizzes
  "chap-1": {
    title: "Spiritual Assessment in Hospice",
    passingScore: 80,
    questions: [
      { id: 1, question: "What does FICA stand for in spiritual assessment?", options: ["Faith, Illness, Community, Address", "Faith/Beliefs, Importance, Community, Address in care", "Family, Interests, Culture, Assessment", "Feelings, Insights, Concerns, Actions"], correctAnswer: 1, explanation: "FICA: Faith/Beliefs, Importance/Influence, Community, Address/Action in care." },
      { id: 2, question: "Who is responsible for spiritual assessment in hospice?", options: ["Chaplain only", "All team members contribute, with chaplain providing in-depth assessment", "Nurse only", "Physician only"], correctAnswer: 1, explanation: "All team members screen for spiritual needs; chaplains provide comprehensive spiritual assessment." },
      { id: 3, question: "What is the HOPE spiritual assessment?", options: ["A depression screening", "Sources of Hope, Organized religion, Personal spirituality, Effects on care", "Hospital assessment tool", "Outcome measure"], correctAnswer: 1, explanation: "HOPE: Hope/meaning, Organized religion, Personal spirituality, Effects on care and decisions." },
      { id: 4, question: "How should spiritual needs be integrated into care?", options: ["Kept separate from medical care", "Documented and addressed in the interdisciplinary care plan", "Only addressed at patient request", "Referred out of hospice"], correctAnswer: 1, explanation: "Spiritual needs should be documented and integrated into the interdisciplinary care plan." },
      { id: 5, question: "What distinguishes spirituality from religion?", options: ["They are exactly the same", "Spirituality is broader, encompassing meaning and purpose; religion is organized belief system", "Religion is more important", "Spirituality is only for non-believers"], correctAnswer: 1, explanation: "Spirituality encompasses meaning, purpose, and connection; religion is an organized system of beliefs and practices." }
    ]
  },
  "chap-2": {
    title: "Multi-Faith End-of-Life Care",
    passingScore: 80,
    questions: [
      { id: 1, question: "Why is cultural humility important in spiritual care?", options: ["It's not important", "It acknowledges we cannot know everything about another's beliefs", "It replaces learning about cultures", "It means ignoring differences"], correctAnswer: 1, explanation: "Cultural humility acknowledges our limitations and commits to learning from each individual's experience." },
      { id: 2, question: "What should you do if unsure about a patient's religious practices?", options: ["Assume based on their background", "Ask the patient or family respectfully about their preferences", "Avoid the topic entirely", "Look it up online during the visit"], correctAnswer: 1, explanation: "Respectfully ask the patient or family about their specific practices and preferences." },
      { id: 3, question: "In Jewish tradition, what may be important at end of life?", options: ["Nothing specific", "Shomer (companion), not leaving body alone, prompt burial", "Avoiding all rituals", "Only medical interventions"], correctAnswer: 1, explanation: "Jewish tradition may include having a shomer (companion), not leaving the body alone, and prompt burial." },
      { id: 4, question: "How should chaplains approach patients with no religious affiliation?", options: ["Skip spiritual care entirely", "Explore sources of meaning, hope, and connection without religious assumptions", "Try to convert them", "Only visit if requested"], correctAnswer: 1, explanation: "Explore meaning, purpose, and connection without imposing religious frameworks." },
      { id: 5, question: "What is the chaplain's role when family religious views conflict with patient's?", options: ["Side with the family", "Advocate for patient's expressed spiritual wishes", "Avoid involvement", "Defer to medical team"], correctAnswer: 1, explanation: "The chaplain advocates for the patient's own expressed spiritual wishes and values." }
    ]
  },
  "chap-3": {
    title: "Ministry of Presence",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is the 'ministry of presence'?", options: ["Giving advice", "Being fully present without agenda, offering compassionate accompaniment", "Praying constantly", "Talking to fill silence"], correctAnswer: 1, explanation: "Ministry of presence is being fully, attentively present without agenda—compassionate accompaniment." },
      { id: 2, question: "When is therapeutic silence appropriate?", options: ["Never", "When allowing space for reflection, processing emotions, or sacred moments", "Only when you don't know what to say", "To end the visit quickly"], correctAnswer: 1, explanation: "Therapeutic silence provides space for reflection, emotional processing, and honoring sacred moments." },
      { id: 3, question: "How can a chaplain create 'sacred space'?", options: ["Only in a chapel", "Through intentional presence, adjusting environment, honoring the moment", "Using religious objects only", "By leaving the room quiet"], correctAnswer: 1, explanation: "Sacred space is created through intentional presence, environmental adjustments, and honoring the moment." },
      { id: 4, question: "What does active listening involve in chaplaincy?", options: ["Waiting to respond", "Full attention, reflecting feelings, and being present without judgment", "Taking detailed notes", "Offering solutions quickly"], correctAnswer: 1, explanation: "Active listening involves full attention, reflecting feelings, and non-judgmental presence." },
      { id: 5, question: "Why might a patient benefit from silence more than words?", options: ["Because chaplains shouldn't talk", "Words can be inadequate; presence and silence honor the depth of experience", "Patients don't like conversation", "It saves time"], correctAnswer: 1, explanation: "Sometimes words are inadequate; silent presence honors the depth of the human experience." }
    ]
  },
  "chap-4": {
    title: "Spiritual Distress & Existential Suffering",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is spiritual distress?", options: ["Physical pain", "Disruption in beliefs, values, or connection that causes suffering", "Religious confusion", "Disagreement with chaplain"], correctAnswer: 1, explanation: "Spiritual distress is a disruption in one's beliefs, meaning, or connection that causes suffering." },
      { id: 2, question: "Which is a common existential concern at end of life?", options: ["Insurance coverage", "Questions about meaning, legacy, forgiveness, and what happens after death", "Medication schedules", "Visiting hours"], correctAnswer: 1, explanation: "Common existential concerns include meaning, legacy, relationships, forgiveness, and death." },
      { id: 3, question: "How can chaplains support meaning-making?", options: ["Provide answers to all questions", "Help patients explore their own sources of meaning through reflection and life review", "Avoid difficult questions", "Focus only on religious beliefs"], correctAnswer: 1, explanation: "Chaplains help patients explore and articulate their own sources of meaning through reflection." },
      { id: 4, question: "What is 'realistic hope' in hospice?", options: ["False optimism", "Hope that shifts focus from cure to comfort, connection, and quality", "Giving up hope", "Medical hope only"], correctAnswer: 1, explanation: "Realistic hope shifts from cure to comfort, meaningful moments, relationships, and quality of life." },
      { id: 5, question: "When should spiritual distress be referred to the chaplain?", options: ["Never", "When screening identifies spiritual concerns or patient expresses spiritual suffering", "Only for religious patients", "After death"], correctAnswer: 1, explanation: "Refer when screening identifies concerns or patient expresses spiritual pain or questions." }
    ]
  },
  "chap-5": {
    title: "Death Vigil & Memorial Services",
    passingScore: 80,
    questions: [
      { id: 1, question: "What is the purpose of a death vigil?", options: ["To speed up death", "To provide presence, support, and ritual during the dying process", "To keep family away", "Medical monitoring only"], correctAnswer: 1, explanation: "A death vigil provides companionship, support, and often ritual during the dying process." },
      { id: 2, question: "What should be considered when planning a memorial service?", options: ["Chaplain's preferences", "Patient/family wishes, cultural practices, and meaningful elements", "Standard format for all", "Cost only"], correctAnswer: 1, explanation: "Consider patient/family wishes, cultural/religious practices, and personally meaningful elements." },
      { id: 3, question: "What is legacy work in hospice?", options: ["Legal documentation", "Helping patients create lasting meaningful gifts (letters, recordings, memory books)", "Estate planning", "Obituary writing"], correctAnswer: 1, explanation: "Legacy work helps patients create meaningful gifts like letters, recordings, or memory projects." },
      { id: 4, question: "How might a chaplain support an atheist patient at end of life?", options: ["Try to change their beliefs", "Honor their worldview and explore meaning, connections, and legacy without religious framing", "Avoid visiting them", "Only visit if requested"], correctAnswer: 1, explanation: "Honor their worldview; explore meaning, connections, and legacy without imposing religious frameworks." },
      { id: 5, question: "What is the role of ritual in grief?", options: ["Rituals are outdated", "Rituals provide structure, meaning, and community support in processing loss", "Only religious people need rituals", "Rituals delay grief"], correctAnswer: 1, explanation: "Rituals provide structure, meaning, and community support that help process grief." }
    ]
  }
};

export default COURSE_QUIZZES;
